'use client';

import {
  styled,
  TextField as MuiTextField,
  TextFieldProps,
} from '@mui/material';
import { forwardRef } from 'react';
import FormHelperText from './FormHelperText';

const StyledLink = styled(MuiTextField)`
  margin-bottom: 1rem;
`;

const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (props: TextFieldProps, ref) => {
    return (
      <StyledLink
        ref={ref}
        slots={{ formHelperText: FormHelperText }}
        {...props}
      />
    );
  },
);

TextField.displayName = 'TextField';

export default TextField as typeof MuiTextField;
